module.exports = __webpack_public_path__ + "static/media/Quicksand-Light.10ce81d2.ttf";